import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

import { SnackBar } from '../snackbar/snackbar.service';
import * as actions from '../actions/notification.actions';

/**
 * Notification redux effects
 *
 * @export
 * @class NotificationEffects
 */
@Injectable()
export class NotificationEffects {
  constructor(private actions$: Actions, private snackbar: SnackBar) {}

  /**
   * Open notification effect used to open a snackbar using the redux store
   *
   * @type {Observable<Action>}
   * @memberof NotificationEffects
   */
  @Effect()
  open$: Observable<Action> = this.actions$.pipe(
    ofType(actions.OPEN),
    map((action: actions.Open) => {
      this.snackbar.addSnackBar(action.payload);
      return new actions.AddNotification(action.payload);
    })
  );

  /**
   * Close/Dismiss notification effect used to close a snackbar which is currently opened.
   *
   * @type {Observable<Action>}
   * @memberof NotificationEffects
   */
  @Effect()
  dismiss$: Observable<Action> = this.actions$.pipe(
    ofType(actions.DISMISS),
    map(() => {
      this.snackbar.dismiss();
      return new actions.Dismissing();
    })
  );
}
